<div class="survey-content mt-5">
  <div class="empty-header"></div>
  <div class="empty-button"></div>
  <div class="empty"></div>
  <div class="empty"></div>
  <div class="empty"></div>
  <div class="empty"></div>
  <div class="empty"></div>
</div>
